import { colors } from "@/styles/constants";
import { Onfido } from "onfido-sdk-ui";
import { Handle, SdkParameters } from "onfido-sdk-ui/types/Onfido";
export type OnfidoConfig = SdkParameters;

export const createOnfidoConfig = ({
  token: sdkToken,
  onComplete,
  onError,
  brand,
}: any): OnfidoConfig => ({
  token: sdkToken,
  containerId: "onfido-mount",
  language: {
    locale: "en_US",
  },
  steps: [
    {
      type: "welcome",
      options: {
        title: "Identity verification",
        descriptions: [
          `${brand} has partnered with market-leading biometric identity verification provider, Onfido, to protect you and the companies we work with.`,
          "Please click “Continue” and follow the instructions to verify your identity.",
        ],
        nextButton: "Continue",
      },
    },
    {
      type: "document",
      options: {
        documentTypes: {
          driving_licence: { country: "GBR" },
          national_identity_card: {},
          passport: {},
          residence_permit: { country: "GBR" },
        },
        uploadFallback: true,
        useLiveDocumentCapture: true,
      },
    },
  ],

  theme: {
    name: "light",
    config: {
      fontFamily: "DM Sans, sans-serif",

      colorContentTitle: colors.titleText,
      colorContentSubtitle: colors.titleText,
      colorContentBody: colors.bodyText,

      colorBackgroundButtonPrimary: colors.saveButtonBackground,
      colorContentButtonPrimaryText: colors.bodyText,

      colorBackgroundButtonSecondary: colors.continueButtonBackground,
      colorBorderButtonSecondary: colors.continueButtonBackground,
      colorContentLinkTextHover: colors.bodyText,
      colorBorderLinkUnderline: colors.saveButtonBackground,
      colorBackgroundLinkHover: colors.saveButtonBackground,
      colorBackgroundLinkActive: colors.saveButtonBackground,

      colorBorderDocTypeButtonHover: colors.saveButtonBackground,
    },
  },
  onComplete,
  onError,
});

export const initOnfido = (config: OnfidoConfig): Handle => {
  return Onfido.init(config);
};
